import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { endpoints } from "../../constants/endpoints";
import { toast } from "react-toastify";
import api from "../../services/instance";

export const UserSingUpAPI = createAsyncThunk(
    'UserSingUpAPI',
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.post(endpoints.register(), data, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            return response.data;
        } catch (error) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue({ message: 'Something went wrong' });
        }
    }
)

const initialState = {
    loading: false,
    newUser: "",
}

export const UserSignUp = createSlice({
    initialState,
    name: "UserSignUp",
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(UserSingUpAPI.pending, (state, action) => {
            state.loading = true;
        });

        builder.addCase(UserSingUpAPI.fulfilled, (state, action) => {
            state.loading = false;
            state.newUser = action.payload.data
        })

        builder.addCase(UserSingUpAPI.rejected, (state, action) => {
            state.loading = false;
            const errors = action.payload?.errors;
            if (errors) {
                Object.values(errors).forEach((errorArray) => {
                    errorArray.forEach((message) => {
                        toast.error(message);
                    });
                });
            } else {
                const defaultMessage = action.payload?.message || "Something went wrong. Invalid Data.";
                toast.error(defaultMessage);
            }
        });
    }
})

export const { } = UserSignUp.actions
export default UserSignUp.reducer